import {
  toggleLinks,
  initComponents,
  fixVH,
  scrollToLinks,
  markLazyLoadedImages,
  lazyLoadVideos,
  inFieldLabels,
  markScrolledDown,
  markScrollDirection,
  markItemsInViewport,
  markEmpty, markImageCornerLightness,
  getCustomPropertyValue,
} from "@/utils";


const win = <any>window;
const $ = win.jQuery;


window.addEventListener('DOMContentLoaded', async () => {
  win.__webpack_public_path__ = (<any>window).siteOptions.themePath + '/js/public/';

  fixVH();
  lazyLoadVideos();
  inFieldLabels();
  markScrollDirection();
  markEmpty();

  markScrolledDown(() => getHeaderHeight() + (getCustomPropertyValue('--scroll-threshold') || 100), 'is-down');
  markScrolledDown(() => getHeaderHeight(), 'is-before-down');

  initComponents([
    'panel-toggle', 'menu-toggle', 'toggle-class', 'calculate-height', 'newsletter-form',
    'check-intersection', 'swiper-slideshow', 'scroll-to', 'custom-select', 'focus-trap',
    'in-viewport', 'product-card', 'custom-cursor', 'lenis-loader', 'scroll-carousel',
    'mark-rows'
  ]);


  document.documentElement.classList.add('is-loaded');
});

function getHeaderHeight() {
  return parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height').trim());
}
